import useReveal from "../hooks/useReveal";

/**
 * Simple scroll-reveal wrapper. Children fade up once the element scrolls
 * into view. Pass `delay` (ms) to stagger sibling reveals.
 */
export default function Reveal({ children, as: Tag = "div", delay = 0, className = "", ...rest }) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
      className={`reveal-target ${visible ? "is-visible" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
